import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d0016b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "images" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import appConfig from "@/modules/appConfig"
import { clearActiveWidget, setActiveWidget } from "@/modules/esriMeasure"
import { showLoadingToast, closeToast } from "vant"

// 测量距离

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const distance = () => {
  clearActiveWidget()
  const type = appConfig.activeView.type
  let select = type === "2d" ? "distance2D" : "distance3D"
  showLoadingToast({
    message: "工具初始化中...",
    forbidClick: true,
    duration: 0
  })
  setActiveWidget(select).finally(() => {
    closeToast()
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "tool-item",
      onClick: distance
    }, _hoisted_2)
  ]))
}
}

})